/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/job.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PipelineSpecRuntimeConfig } from './PipelineSpecRuntimeConfig';
import {
  PipelineSpecRuntimeConfigFromJSON,
  PipelineSpecRuntimeConfigFromJSONTyped,
  PipelineSpecRuntimeConfigToJSON,
  PipelineSpecRuntimeConfigToJSONTyped,
} from './PipelineSpecRuntimeConfig';
import type { ApiParameter } from './ApiParameter';
import {
  ApiParameterFromJSON,
  ApiParameterFromJSONTyped,
  ApiParameterToJSON,
  ApiParameterToJSONTyped,
} from './ApiParameter';

/**
 *
 * @export
 * @interface ApiPipelineSpec
 */
export interface ApiPipelineSpec {
  /**
   * Optional input field. The ID of the pipeline user uploaded before.
   * @type {string}
   * @memberof ApiPipelineSpec
   */
  pipeline_id?: string;
  /**
   * Optional output field. The name of the pipeline.
   * Not empty if the pipeline id is not empty.
   * @type {string}
   * @memberof ApiPipelineSpec
   */
  pipeline_name?: string;
  /**
   * Optional input field. The marshalled raw argo JSON workflow.
   * This will be deprecated when pipeline_manifest is in use.
   * @type {string}
   * @memberof ApiPipelineSpec
   */
  workflow_manifest?: string;
  /**
   * Optional input field. The raw pipeline JSON spec.
   * @type {string}
   * @memberof ApiPipelineSpec
   */
  pipeline_manifest?: string;
  /**
   *
   * @type {Array<ApiParameter>}
   * @memberof ApiPipelineSpec
   */
  parameters?: Array<ApiParameter>;
  /**
   *
   * @type {PipelineSpecRuntimeConfig}
   * @memberof ApiPipelineSpec
   */
  runtime_config?: PipelineSpecRuntimeConfig;
}

/**
 * Check if a given object implements the ApiPipelineSpec interface.
 */
export function instanceOfApiPipelineSpec(value: object): value is ApiPipelineSpec {
  return true;
}

export function ApiPipelineSpecFromJSON(json: any): ApiPipelineSpec {
  return ApiPipelineSpecFromJSONTyped(json, false);
}

export function ApiPipelineSpecFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiPipelineSpec {
  if (json == null) {
    return json;
  }
  return {
    pipeline_id: json['pipeline_id'] == null ? undefined : json['pipeline_id'],
    pipeline_name: json['pipeline_name'] == null ? undefined : json['pipeline_name'],
    workflow_manifest: json['workflow_manifest'] == null ? undefined : json['workflow_manifest'],
    pipeline_manifest: json['pipeline_manifest'] == null ? undefined : json['pipeline_manifest'],
    parameters:
      json['parameters'] == null
        ? undefined
        : (json['parameters'] as Array<any>).map(ApiParameterFromJSON),
    runtime_config:
      json['runtime_config'] == null
        ? undefined
        : PipelineSpecRuntimeConfigFromJSON(json['runtime_config']),
  };
}

export function ApiPipelineSpecToJSON(json: any): ApiPipelineSpec {
  return ApiPipelineSpecToJSONTyped(json, false);
}

export function ApiPipelineSpecToJSONTyped(
  value?: ApiPipelineSpec | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    pipeline_id: value['pipeline_id'],
    pipeline_name: value['pipeline_name'],
    workflow_manifest: value['workflow_manifest'],
    pipeline_manifest: value['pipeline_manifest'],
    parameters:
      value['parameters'] == null
        ? undefined
        : (value['parameters'] as Array<any>).map(ApiParameterToJSON),
    runtime_config: PipelineSpecRuntimeConfigToJSON(value['runtime_config']),
  };
}
